<template>
  <span
    @click="deleteCallback()"
    :title="$t('delete')"
    class="btn btn-primary white delete"
  >
    <i class="fa fa-trash" aria-hidden="true"></i>
  </span>
</template>
<script>
export default {
  name: "volcan-btn-delete",
  props: ["deleteCallback"],
  data: function () {
    return {};
  },
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/btn-delete.vue